// src/pages/Reports.jsx

import React, { useMemo, useState } from 'react';
import { LoadingSpinner } from '../App';
import { useReportsData } from '../hooks/useReportsData';
import SummaryBox from '../components/reports/SummaryBox';
import RecordsTable from '../components/reports/RecordsTable';
import {
  PageShell,
  PageError,
  RefreshButton,
  PAGE,
  getToolbarStyle,
} from '../components/ui';

export default function Reports() {
  const { pallets, loading, refreshing, error, refreshData } = useReportsData();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPallets = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return pallets;
    return pallets.filter(
      (pallet) =>
        pallet.name.toLowerCase().includes(term) ||
        pallet.images.some((url) => String(url || '').toLowerCase().includes(term))
    );
  }, [pallets, searchTerm]);

  const totalImages = useMemo(() => {
    return pallets.reduce(
      (acc, pallet) => acc + pallet.images.filter(Boolean).length,
      0
    );
  }, [pallets]);

  if (loading) {
    return (
      <LoadingSpinner
        title="Loading Unloading Dock"
        subtitle="Fetching pallet damage records..."
      />
    );
  }

  return (
    <PageShell>
      <div style={{ ...getToolbarStyle(), justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <SummaryBox label="Pallets" value={pallets.length} />
          <SummaryBox label="Images" value={totalImages} />
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flex: 1, maxWidth: 400, marginLeft: 16 }}>
          <input
            type="text"
            placeholder="Search pallets…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              minWidth: 200,
              padding: '11px 14px',
              fontSize: 14,
              border: `1px solid ${PAGE.colors.line}`,
              borderRadius: PAGE.radius.input,
              outline: 'none',
              background: PAGE.colors.bg,
              fontFamily: PAGE.fontFamily,
            }}
          />
          <RefreshButton onClick={refreshData} refreshing={refreshing} />
        </div>
      </div>

      {error ? (
        <PageError message={error} />
      ) : filteredPallets.length === 0 ? (
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: PAGE.colors.muted,
            fontWeight: 700,
            fontSize: 15,
            background: PAGE.colors.surface,
            border: `1px solid ${PAGE.colors.line}`,
            borderRadius: PAGE.radius.card,
          }}
        >
          No records found.
        </div>
      ) : (
        <RecordsTable pallets={filteredPallets} />
      )}
    </PageShell>
  );
}